<template>
  <a-config-provider :locale="zh_CN">
    <template slot="renderEmpty">
      <div style="text-align: center">
        <img style="width: 280px" src="../assets/original.png" alt />
        <p>暂无数据</p>
      </div>
    </template>
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>
<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import { mapState } from "vuex";
export default {
  name: "app",
  data() {
    return {
      zh_CN,
    };
  },
  computed: {
    ...mapState(["apiMessage"]),
  },
  watch: {
    apiMessage(val) {
      if (val && val.length > 0) {
        this.$message.error(val, 2);
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mybtn{
  width: 100%;
  .ant-modal-footer{
    text-align: center;
  }
  .ant-modal-header{
    text-align: center;
  }
}
.myprogress{
  margin-top: 20px;
  margin-bottom: 15px;
  .el-progress-bar{
    padding-right: 70px!important;
  }
  .el-progress__text{
    width: 120px;
    font-size:unset!important;
  }
}
</style>
